import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { setFormElementType, SetFormElementTypeAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useFormElementType(): LocalOperation<
	(payload: ActionPayload<SetFormElementTypeAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<SetFormElementTypeAction>) {
		dispatch(setFormElementType(payload));
	}

	return handler;
}
